import { Company } from '../types/company';
import { http } from '../util/https.util';

const DUPLICATE = '/api/company/duplicate';
const UPDATE_STATUS = '/api/company/update_status';

export namespace CompanyRequest {
  export const duplicate = async (payload: { name: string; companyId: string }): Promise<Company> => {
    return (await http.post(DUPLICATE, payload)).data;
  };

  export const updateStatus = async (payload: { companyId: string; status: string }): Promise<Company> => {
    return (await http.post(UPDATE_STATUS, payload)).data;
  };
}
